import { useState } from 'react'

import { apiPost } from '../lib/api'
import { Icon } from '../ui/Icon'

/**
 * Aviso de que el panel está abierto con la puerta provisoria de links firmados
 * y no con Cloudflare Access.
 *
 * POR QUÉ ESTE BANNER NO ES DECORACIÓN
 * ====================================
 * El modo `share` existe para una sola cosa: que el panel se pueda compartir hoy
 * sin que el header de Access sea suplantable. Es un puente, y un puente sin
 * cartel se vuelve permanente por olvido: nadie recuerda volver a configurar
 * Access si el panel "ya funciona". El cartel nombra la vía definitiva para que
 * la deuda quede a la vista de todos los que entran, no solo de quien deployó.
 *
 * Lo prende el servidor (`config.authMode`), nunca una constante del front: el
 * front no puede saber si Access está delante del dominio.
 *
 * Lleva la salida adentro. Sin un botón de cerrar acceso, revocar en un
 * dispositivo prestado obliga a rotar el secreto y echar a todo el equipo.
 */
export interface ShareModeBannerProps {
  visible: boolean
}

export function ShareModeBanner({ visible }: ShareModeBannerProps) {
  const [saliendo, setSaliendo] = useState(false)

  if (!visible) return null

  async function cerrar() {
    setSaliendo(true)
    try {
      await apiPost('/api/share/logout', {})
    } catch {
      // Da igual por qué falló: la cookie es `HttpOnly`, así que el front no la
      // puede borrar por su cuenta y lo único honesto es recargar y mostrar el
      // estado real que decida el servidor.
    }
    window.location.assign('/')
  }

  return (
    <div
      role="status"
      data-testid="share-mode-banner"
      className="flex items-center gap-2 border-b border-danger bg-danger-soft px-5 py-1.5 text-meta text-text"
    >
      <Icon name="critico" size={13} className="text-danger-text" />
      <span>
        <b className="font-semibold">Acceso temporal por link</b> — este panel
        todavía no está detrás de Cloudflare Access, que es la vía definitiva.
        Tu link es personal: no lo reenvíes.
      </span>
      <button
        type="button"
        onClick={cerrar}
        disabled={saliendo}
        className="ml-auto shrink-0 rounded border border-danger px-2 py-0.5 font-semibold text-danger-text hover:bg-danger-soft disabled:opacity-50"
      >
        {saliendo ? 'Cerrando…' : 'Cerrar acceso'}
      </button>
    </div>
  )
}
